<template>
  <div class="index">
    <AppBar />
    <router-view id="router" />
    <Footer />
  </div>
</template>

<script>
import AppBar from "./components/AppBar.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "Index",
  components: {
    AppBar,
    Footer
  },
  created() {
    if (this.$router.currentRoute.path == "/") this.$router.push("/not-found");
  }
};
</script>

<style scoped></style>
